// ⚠️ AUTO-GENERATED — DO NOT EDIT MANUALLY
// Source: ./svg/IconArrowLeftBold.svg — regenerate with `nx run creditflowresearch-uilib:icons-generate --write`
import BaseIcon from './BaseIcon';
import type { IIconProps } from './types';

const IconArrowLeftBold = (props: IIconProps) => (
  <BaseIcon viewBox="0 0 16 16" fill="currentColor" { ...props }>
    <path d="m5.17958,10.20943l-2.08588,-2.0859l7.76424,-7.76423l2.08588,2.08588l-7.76424,7.76424z" />
    <path d="m3.0937,8.13755l2.08588,-2.0859l7.76424,7.76424l-2.0859,2.08585l-7.76423,-7.7642z" />
  </BaseIcon>
);

export default IconArrowLeftBold;
